import authState from './authState';

export default authState.open;
